import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getAllConnections(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async createInstance(instanceName, tenantName, isOfficial = false, isUnlimited = false, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance';
    try {
      return await axios.post('',  {
        name: instanceName,
        tenantName: tenantName,
        isOfficial: isOfficial,
        isUnlimited: isUnlimited
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async updateInstance(data, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance/update';
    try {
      return await axios.post('',  {
        ...data
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async syncMessages(id, daysAgo, token, tenantName, unlimitedSync) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance/syncMessages';
    try {
      return await axios.post('', {
        id,
        daysAgo,
        tenantName,
        unlimitedSync
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async deleteInstance(id, token, tenantName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance/delete';
    try {
      return await axios.post('', {
        id,
        tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async restartInstance(id, token, tenantName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance/restart';
    try {
      return await axios.post('', {
        id,
        tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateNewToken(id, token, tenantName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instance/generateNewToken';
    try {
      return await axios.post('', {
        id,
        tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  }
}
